<!-- start payment -->
<ng-container *ngIf="NavigateToTapPayment">
    <app-payment 
        [metadata]="MetaData"
        [type]="PaymentTypeAd"
        redirect="payment-result"
        [soldItemInfo]="ResponseAdData"
    />
</ng-container>
<!-- end payment -->

<!-- start advertiser-class  -->
<ng-container *ngIf="ShowAdvertiserClass === true && isOperationCreatedMode">
    <app-overlay-container>
        <app-advertiser-class 
            (useSubmit)="HandlerCreationType($event)"
            (useClose)="ShowAdvertiserClass = false" 
        />
    </app-overlay-container>
</ng-container>
<!-- end advertiser-class  -->

<!-- start app-build-ad -->
<div class="build_adv">

    <!-- import app-second-header -->
    <app-second-header>
        
        <div class="wrap_navigate">
            <!-- app-navigation -->
            <app-navigation
                [style]="{top: '60px'}" 
                [navigate]="{path: '/', label: (routeData | async)?.label} "
            />
        </div>

        <div class="wrap_content position-relative d-flex align-items-center flex-column flex-sm-row">
            <div class="wrap_icon_with_title text-center">
                <div class="wrap_img border_def_2th d-flex justify-content-center align-items-center">
                    <img src="/assets//img/add_request.svg" alt="add_request">
                </div>
                <span class="label_lg_bold d-block">{{(routeData | async)?.title}}</span>
            </div>
            <div class="wrao_des text-center text-sm-start mt-2 mt-sm-0">
                <!-- <p
                    class="mb-0 text_md_normal"
                    *ngIf="(UserInfo | async)?.type == USER_TYPES.normalUser; else NotNormalUser" 
                >
                    هي خدمة تمكنك من عرض عقاراتك بالتطبيق مقابل كل إضافة رسوم ثابتة هي <strong> {{(Setting | async)?.adsCost}} ريال </strong>
                </p> -->
                <!-- <ng-template #NotNormalUser>
                    <ng-container *ngIf="(UserInfo | async)?.hasAdsPackage == false">
                        <p class="mb-0 text_md_normal" >
                            هي خدمة تمكنك من عرض عقاراتك بالتطبيق مقابل الاشتراك بأحدي <strong> باقات الاعلانات </strong>
                        </p>
                    </ng-container>
                    <ng-container *ngIf="(UserInfo | async)?.hasAdsPackage == true">
                        <p class="mb-0 text_md_normal">
                            هي خدمة تمكنك من عرض عقاراتك بالتطبيق ولديك عدد معين حسب نوع الباقة, المتبقي لعدد باقتك هو {{(UserInfo | async)?.availableAds}} اضافة <br> <strong> باقات الاعلانات </strong>
                        </p>
                    </ng-container>
                </ng-template> -->
            </div>
        </div>

        <!-- start region field -->
        <div class="wrap_region" [class.d-none]="PreviewCurrentFormData != null" [formGroup]="Form">
            <ng-select 
                bindValue="id"
                [items]="Regions"
                [clearable]="false"
                class="text-center"
                bindLabel="regionName"
                formControlName="region" 
                placeholder="اختيار المنطقة"
                notFoundText="لا يوجد مناطق متاحة!"
                (change)="HandlerGetCitiesByRegion($event)"

            >
            </ng-select>
            <div class="wrap_validation" *ngIf="control('region').touched && control('region').errors">
                <app-validation-input 
                    class="mb-0"
                    [text]="'هذا الحقل مطلوب'"
                >
                </app-validation-input>
            </div>
        </div>
        <!-- end region field -->

    </app-second-header> 
    
    <div class="custom_container">
        <form [formGroup]="Form" (ngSubmit)="submit()">
            <div class="wrap_box_form" [class.d-none]="PreviewCurrentFormData != null" >
                <div class="row">

                    <div class="col-12">
                        <h4 class="title text-center color_black my-4">الان يمكنك عرض عقارك للبيع</h4>
                    </div>

                    <!-- start city field -->
                    <div class="col-12 col-md-6 wrap_full_control">
                        <app-label [required]="true" title="المدينة"></app-label>
                        <div class="wrap_box">
                            <ng-select 
                                bindValue="id"
                                [items]="Cities"
                                class="text-center"
                                [clearable]="false"
                                bindLabel="cityName"
                                formControlName="city"
                                placeholder="اختيار المدينة"
                                notFoundText="لا يوجد مدن متاحة!"
                                [loading]="IsLoadingCities"
                                (change)="HandlerGetAreasByCity($event)"
                            >
                            </ng-select>
                            <div class="wrap_validation">
                                <app-validation-input 
                                    class="mb-0"
                                    [text]="'هذا الحقل مطلوب'"
                                    *ngIf="control('city').touched && control('city').errors"
                                >
                                </app-validation-input>
                            </div>
                        </div>
                    </div>
                    <!-- end city field -->

                    <!-- start area field -->
                    <div class="col-12 col-md-6 wrap_full_control">
                        <app-label [required]="true" title="الحي"></app-label>
                        <div class="wrap_box">
                            <ng-select
                                bindValue="id"
                                class="text-center"
                                [clearable]="false"
                                bindLabel="areaName"
                                formControlName="area"
                                placeholder="اختيار الحي"
                                notFoundText="لا يوجد احياء متاحة!"
                                [items]="Areas"
                                [loading]="IsLoadingAreas"
                                (change)="HandlerGetArea($event)"
                                >
                            </ng-select>
                            <div class="wrap_validation">
                                <app-validation-input 
                                    class="mb-0"
                                    [text]="'هذا الحقل مطلوب'"
                                    *ngIf="control('area').touched && control('area').errors"
                                >
                                </app-validation-input>
                            </div>
                        </div>
                    </div>
                    <!-- end city field -->

                    <!-- start category field -->
                    <div class="col-12 col-md-6">
                        <div class="wrap_full_control">
                            <app-label [required]="true" title="نوع العقار"></app-label>
                            <div class="wrap_box">
                                <ng-select 
                                    bindValue="id"
                                    class="text-center"
                                    [clearable]="false"
                                    [searchable]="false"
                                    placeholder="الرئيسي"
                                    bindLabel="categoryName"
                                    formControlName="category"
                                    [items]="FilteredCategories"
                                    notFoundText="لا يوجد فئة رئيسية متاحة!"
                                    (change)="HandlerGetSubCategoryByMain($event)"
                                >
                                </ng-select>
                                <div class="wrap_validation">
                                    <app-validation-input 
                                        class="mb-0"
                                        [text]="'هذا الحقل مطلوب'"
                                        *ngIf="control('category').touched && control('category').errors"
                                    >
                                    </app-validation-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end category field -->

                    <!-- start subCategory field -->
                    <div class="col-12 col-md-6">
                        <div class="wrap_full_control witout_label">
                            <div class="wrap_box">
                                <ng-select 
                                    bindValue="id"
                                    class="text-center"
                                    [clearable]="false"
                                    [searchable]="false"
                                    placeholder="الفرعي"
                                    bindLabel="categoryName"
                                    [items]="SubCatagories"
                                    formControlName="subCategory"
                                    [loading]="IsLoadingProperties"
                                    notFoundText="لا يوجد فئة فرعية متاحة!"
                                    (change)="HandlerPropertiesBySubCategory($event)"
                                >
                                </ng-select>
                                <div class="wrap_validation">
                                    <app-validation-input 
                                        class="mb-0"
                                        [text]="'هذا الحقل مطلوب'"
                                        *ngIf="control('subCategory').touched && control('subCategory').errors"
                                    >
                                    </app-validation-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end subCategory field -->

                    <!-- start subCategory field -->
                    <div class="col-12">
                        <app-label [required]="true" title="نوع المشروع"></app-label>
                        <div class="wrap_box">
                            <ng-select 
                                bindLabel="title"
                                bindValue="value"
                                class="text-center"
                                [clearable]="false"
                                [searchable]="false"
                                formControlName="type"
                                placeholder="نوع المشروع"
                                notFoundText="لا يوجد انواع متاحة!"
                                [items]="[
                                    { title: 'مشروع جاهز', value: ADVERTISEMENT_TYPE.Ready},
                                    { title: 'مشروع بيع علي الخريطة', value: ADVERTISEMENT_TYPE.offPlanSale}
                                ]"
                            >
                            </ng-select>
                            <div class="wrap_validation">
                                <app-validation-input 
                                    class="mb-0"
                                    [text]="'هذا الحقل مطلوب'"
                                    *ngIf="control('type').touched && control('type').errors"
                                >
                                </app-validation-input>
                            </div>
                        </div>
                    </div>
                    <!-- end subCategory field -->                    

                    <!-- start title field -->
                    <!-- <ng-container *ngIf="isVipAd">
                        <div class="col-12 col-md-6">
                            <div class="wrap_box">
                                <app-label [required]="true" title="عنوان الاعلان"></app-label>
                                <div class="wrap_input">
                                    <app-input-field
                                        type="text"
                                        name="title_ar"
                                        formControlName="title_ar"
                                        placeholder="... اكتب هنا"
                                        [validatorsErrorMsg]="true"
                                    />
                                </div>
                            </div>
                        </div>
                    </ng-container> -->
                    <!-- end title field -->

                    <!-- start address field -->
                    <div  class="col-12">
                        <div class="wrap_box">
                            <app-label [required]="true" [title]="ControlLabelValueType.addressLabel"></app-label>
                            <div class="wrap_input">
                                <app-input-field
                                    type="text"
                                    [name]="'address_ar'"
                                    formControlName="address_ar"
                                    placeholder="... اكتب هنا"
                                    [validatorsErrorMsg]="true"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- end address field -->

                    <!-- start controls land -->
                    <ng-container *ngIf="isLand">
                        
                        <!-- start blockNumber field -->
                        <div class="col-12 col-md-6">
                            <div class="wrap_box">
                                <app-label title="رقم البلوك" />
                                <div class="wrap_input">
                                    <app-input-field
                                        type="text"
                                        name="blockNumber"
                                        placeholder="... اكتب هنا"
                                        formControlName="blockNumber"
                                        matchNumbersOnly
                                        removeZerosAtFirst
                                        [validatorsErrorMsg]="true"
                                    />
                                </div>
                            </div>
                        </div>
                        <!-- end blockNumber field -->

                        <!-- start zoneNumber field -->
                        <div class="col-12 col-md-6">
                            <div class="wrap_box">
                                <app-label title="رقم الزون" />
                                <div class="wrap_input">
                                    <app-input-field
                                        type="text"
                                        name="zoneNumber"
                                        placeholder="... اكتب هنا"
                                        formControlName="zoneNumber"
                                        matchNumbersOnly
                                        removeZerosAtFirst
                                        [validatorsErrorMsg]="true"
                                    />
                                </div>
                            </div>
                        </div>
                        <!-- end zoneNumber field -->

                    </ng-container>
                    <!-- end controls land -->

                    <!-- start streetName field -->
                    <div class="col-12 col-md-6">
                        <div class="wrap_box">
                            <app-label title="اسم الشارع"></app-label>
                            <div class="wrap_input">
                                <app-input-field
                                    type="text"
                                    [name]="'streetName'"
                                    placeholder="... اكتب هنا"
                                    formControlName="streetName"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- end streetName field -->
                     
                    <!-- start unitNumber field -->
                    <div class="col-12 col-md-6">
                        <div class="wrap_box">
                            <app-label [title]="ControlLabelValueType?.unitNumberLabel"></app-label>
                            <div class="wrap_input">
                                <app-input-field
                                    type="text"
                                    [name]="'unitNumber'"
                                    formControlName="unitNumber"
                                    placeholder="... اكتب هنا"
                                    [validatorsErrorMsg]="true"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- end unitNumber field -->

                    <!-- start price field -->
                    <div class="col-12 col-md-6">
                        <div class="wrap_full_control">
                            <app-label 
                                [required]="true"
                                [title]="PriceTitle"
                            >
                            </app-label>
                            <div class="wrap_input">
                                <app-input-field
                                    type="text"
                                    [name]="'price'"
                                    convertToAmount
                                    removeZerosAtFirst
                                    formControlName="price"
                                    placeholder="... اكتب هنا"
                                    [validatorsErrorMsg]="true"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- end price field -->

                    <!-- start size field -->
                    <div class="col-12 col-md-6">
                        <div class="wrap_full_control">
                            <app-label [required]="true" [title]="ControlLabelValueType?.sizeLabel"></app-label>
                            <div class="wrap_input">
                                <app-input-field
                                    type="text"
                                    [name]="'size'"
                                    convertToAmount
                                    formControlName="size"
                                    placeholder="... اكتب هنا"
                                    [validatorsErrorMsg]="true"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- end size field -->

                    <!-- start totalPrice field -->
                    <ng-container *ngIf="isPlaning || isLand">
                        <div class="col-12" [class.col-md-6]="IsHasBundledAds">
                            <div class="wrap_box">
                                <app-label [title]="ControlLabelValueType?.totalPriceLabel"></app-label>
                                <div class="wrap_input">
                                    <app-input-field
                                        type="text"
                                        convertToAmount
                                        removeZerosAtFirst
                                        [name]="'totalPrice'"
                                        formControlName="totalPrice"
                                        placeholder="... اكتب هنا"
                                        [validatorsErrorMsg]="true"
                                    />
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <!-- end totalPrice field -->

                    <!-- start startSaleDate -->
                    <ng-container *ngIf="IsHasBundledAds">
                        <div class="col-12" [class.col-md-6]="isPlaning || isLand">
                            <div class="wrap_box">
                                <app-label [required]="true" title="تاريخ بدا البيع"></app-label>
                                <div class="wrap_input">
                                    <app-input-field
                                        type="date"
                                        class="pointer"
                                        name="startSaleDate"
                                        placeholder="... اكتب هنا"
                                        [validatorsErrorMsg]="true"
                                        formControlName="startSaleDate"
                                    />
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <!-- end startSaleDate -->

                    <div class="col-12 mt-3">
                        <app-label title="تفاصيل أخرى" />
                    </div>

                    <!-- start hasDeposit -->
                     <ng-container *ngIf="!IsAdvertisementTypeOffPlanSale && !IsHasBundledAds">
                         <div class="col-12 col-sm-6 col-md-4">
                             <div class="wrap_box">
                                 <app-check-box
                                     name="hasDeposit"
                                     label="اضافة عربون"
                                     formControlName="hasDeposit"
                                     (Change)="ToggleDisableDepositField($event)"
                                 />
                             </div>
                         </div>
                     </ng-container>
                    <!-- end hasDeposit -->

                    <!-- start enableInstallment -->
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="wrap_box">
                            <app-check-box 
                                name="enableInstallment"
                                label="هل تحتاج تقسيط ؟"
                                formControlName="enableInstallment" 
                            />
                        </div>
                    </div>
                    <!-- end enableInstallment -->

                    <!-- start enablePhoneContact -->
                    <div class="col-12 col-sm-6 col-md-4" >
                        <div class="wrap_box">
                            <app-check-box 
                                name="enablePhoneContact"
                                formControlName="enablePhoneContact" 
                                label="السماح بالتواصل عبر الجوال ؟"
                            />
                        </div>
                    </div>
                    <!-- end enablePhoneContact --> 
                     
                    <!-- start Deposit -->
                    <ng-container *ngIf="ShowDepositInput">
                        <div class="col-12 mt-3">
                            <app-label class="main_color" title="قيمة العربون"></app-label>
                            <div class="wrap_input">
                                <app-input-field
                                    type="text"
                                    name="deposit"
                                    convertToAmount
                                    removeZerosAtFirst
                                    formControlName="deposit"
                                    placeholder="... اكتب هنا"
                                    [validatorsErrorMsg]="true"
                                />
                            </div>
                        </div>
                    </ng-container>
                    <!-- end Deposit -->                    

                    <div class="col-12 mt-5"></div>

                    <!-- start Companies field -->
                    <div class="col-12" [class.col-md-6]="control('paymentPlan').enabled">
                        <div class="wrap_full_control">
                            <app-label title="الشركة" [required]="true" />
                            <div class="wrap_box">
                                <ng-select 
                                    bindValue="id"
                                    bindLabel="name"
                                    class="text-center"
                                    [clearable]="false"
                                    [searchable]="false"
                                    [items]="Companies"
                                    formControlName="company"
                                    placeholder="اختيار الشركة"
                                    notFoundText="لا يوجد شركات متاحة!"
                                />
                                <div class="wrap_validation">
                                    <app-validation-input 
                                        class="mb-0"
                                        [text]="'هذا الحقل مطلوب'"
                                        *ngIf="control('company').touched && control('company').errors"
                                    >
                                    </app-validation-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end Companies field -->

                    <!-- start paymentPlan field -->
                    <ng-container *ngIf="control('paymentPlan').enabled">
                        <div class="col-12 col-md-6">
                            <div class="wrap_full_control">
                                <app-label title="خطة الدفع" [required]="control('paymentPlan').getError('required')" />
                                <div class="wrap_box">
                                    <ng-select 
                                        bindValue="id"
                                        bindLabel="name"
                                        class="text-center"
                                        [clearable]="false"
                                        [searchable]="false"
                                        [items]="PaymentPlans"
                                        formControlName="paymentPlan"
                                        placeholder="اختيار خطة الدفع"
                                        notFoundText="لا يوجد خطط دفع متاحة!"
                                    />
                                    <div class="wrap_validation">
                                        <app-validation-input 
                                            class="mb-0"
                                            [text]="'هذا الحقل مطلوب'"
                                            *ngIf="control('paymentPlan').touched && control('paymentPlan').errors"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <!-- end paymentPlan field -->

                    <!-- start Banks -->
                    <div class="col-12 col-md-6">
                        <div class="wrap_full_control">
                            <app-label title="التمويل و البنوك" />
                            <div class="wrap_box">
                                <ng-select 
                                    bindValue="id"
                                    [items]="Banks"
                                    bindLabel="name"
                                    [multiple]="true"
                                    class="text-center"
                                    [clearable]="false"
                                    [searchable]="false"
                                    placeholder="البنوك"
                                    formControlName="banks"
                                    [closeOnSelect]="false"
                                    [clearSearchOnAdd]="true"
                                    notFoundText="لا يوجد بنوك متاحة!"
                                >
                                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                        <div class="ng-value" *ngFor="let item of items | slice:0:2">
                                            <span class="ng-value-label">{{$any(item)?.name}}</span>
                                        </div>
                                        <div class="ng-value" *ngIf="items.length > 2">
                                            <span class="ng-value-label">اكثر... {{items.length - 2}}</span>
                                        </div>
                                    </ng-template>
                                </ng-select>
                                <div class="wrap_validation">
                                    <app-validation-input 
                                        class="mb-0"
                                        [text]="'هذا الحقل مطلوب'"
                                        *ngIf="control('banks').touched && control('banks').errors"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end Banks -->

                    <!-- start SaleServices -->
                    <div class="col-12 col-md-6">
                        <div class="wrap_full_control">
                            <app-label title="خدمات مابعد البيع" />
                            <div class="wrap_box">
                                <ng-select 
                                    bindValue="id"
                                    bindLabel="name"
                                    [multiple]="true"
                                    class="text-center"
                                    [clearable]="false"
                                    [searchable]="false"
                                    placeholder="الخدمات"
                                    [items]="SaleServices"
                                    [closeOnSelect]="false"
                                    [clearSearchOnAdd]="true"
                                    formControlName="services"
                                    notFoundText="لا يوجد بنوك متاحة!"
                                >
                                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                        <div class="ng-value" *ngFor="let item of items | slice:0:2">
                                            <span class="ng-value-label">{{$any(item)?.name}}</span>
                                        </div>
                                        <div class="ng-value" *ngIf="items.length > 2">
                                            <span class="ng-value-label">اكثر... {{items.length - 2}}</span>
                                        </div>
                                    </ng-template>
                                </ng-select>
                                <div class="wrap_validation">
                                    <app-validation-input 
                                        class="mb-0"
                                        [text]="'هذا الحقل مطلوب'"
                                        *ngIf="control('services').touched && control('services').errors"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <ng-container *ngIf="isVipAd == true">
                    </ng-container> -->
                    <!-- end SaleServices -->
                     
                    <!-- start contractType field -->
                    <!-- <div class="col-12">
                        <div class="wrap_full_control">
                            <app-label [required]="true" title="نوع التعاقد"></app-label>
                            <div class="wrap_box">
                                <ng-select 
                                    bindValue="id"
                                    bindLabel="name"
                                    class="text-center"
                                    [clearable]="false"
                                    [searchable]="false"
                                    placeholder="التعاقد"
                                    [items]="ListOfContractType"
                                    formControlName="contractType"
                                    (change)="contractToggle($event?.id)"
                                    notFoundText="لا يوجد انواع تعاقد متاحة!"
                                >
                                </ng-select>
                                <div class="wrap_validation">
                                    <app-validation-input 
                                        class="mb-0"
                                        [text]="'هذا الحقل مطلوب'"
                                        *ngIf="control('contractType').touched && control('contractType').errors"
                                    >
                                    </app-validation-input>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!-- end contractType field -->

                    <!-- start rentType field -->
                     <!-- <ng-container *ngIf="ShowRent">
                         <div class="col-12" @fade>
                             <div class="wrap_box">
                                 <ng-select 
                                     bindValue="id"
                                     bindLabel="name"
                                     class="text-center"
                                     [clearable]="false"
                                     [searchable]="false"
                                     [items]="listOfRentType"
                                     placeholder="نوع التاجير"
                                     formControlName="rentType"
                                     notFoundText="لا يوجد انواع  لي تاجير متاحة!"
                                     (change)="RentToggle($event?.id)"
                                 >
                                 </ng-select>
                                 <div class="wrap_validation">
                                     <app-validation-input 
                                         class="mb-0"
                                         [text]="'هذا الحقل مطلوب'"
                                         *ngIf="control('rentType').touched && control('rentType').errors"
                                     >
                                     </app-validation-input>
                                 </div>
                             </div>
                         </div>
                     </ng-container> -->
                    <!-- end rentType field -->

                    <!-- start Bundled units -->
                    <ng-container *ngIf="IsHasBundledAds === true">
                        <div class="Bundled_ads position-relative">

                            <ng-container *ngIf="isLoadingLiveSearch === true">
                                <app-loader [preventScroll]="true" [sm]="true" size="fa-5x" />
                            </ng-container>

                            <!-- start Building -->
                            <ng-container *ngIf="isBuilding === true">
                                <div class="col-12">
                                    <div class="wrap_full_control">
                                        <app-label [required]="true" title="عدد الطوابق"></app-label>
                                        <div class="wrap_box">
                                            <ng-select 
                                                [items]="Floors"
                                                class="text-center"
                                                [clearable]="false"
                                                [searchable]="true"
                                                formControlName="floors"
                                                placeholder="اختيار عدد الطوابق"
                                                notFoundText="لا يوجد طوابق متاحة!"
                                                (change)="ChildrenCountHandler($event, UnitsControl)"
                                            />
                                        </div>
                                        <div class="wrap_validation">
                                            <app-validation-input 
                                                class="mb-0"
                                                [text]="'هذا الحقل مطلوب'"
                                                *ngIf="control('floors')?.touched && control('floors')?.errors"
                                            >
                                            </app-validation-input>
                                        </div>
                                    </div>
                                </div>
                                <ng-container *ngIf="UnitsControl?.controls?.length > 0">
                                    <div class="col-12 units">
                                        <div class="hr my-2"></div>
                                        <div class="row mt-3 wrap_units custom_scroll align-content-start">
                                            <ng-container formArrayName='units'>
                                                <ng-container *ngFor="let unit of UnitsControl.controls; let i = index; let control as index">
                                                    <ng-container [formGroupName]="i">
                                                        <div class="col-3 mb-2">
                                                            <div 
                                                                class="tab_unit label_lg_bold border_r color_white text-center"
                                                            >
                                                                الطابق رقم 
                                                                <span class="ms-2">{{control.get('floor')?.value}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-9 mb-2">
                                                            <div class="wrap_unit">
                                                                <ng-select 
                                                                    bindValue="id"
                                                                    [multiple]="true"
                                                                    class="text-center"
                                                                    [clearable]="false"
                                                                    formControlName="unit"
                                                                    bindLabel="unitNumber"
                                                                    [closeOnSelect]="false"
                                                                    placeholder="اختيار الوحدات"
                                                                    notFoundText="لا يوجد وحدات متاحة!"
                                                                    [items]="filteredUnits$ | async"
                                                                >
                                                                </ng-select>
                                                                <div class="wrap_validation">
                                                                    <app-validation-input 
                                                                        class="mb-0"
                                                                        [text]="'هذا الحقل مطلوب'"
                                                                        *ngIf="control.get('unit')?.touched && control.get('unit')?.errors"
                                                                    >
                                                                    </app-validation-input>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <!-- end Building -->
    
                            <!-- start Planing -->
                            <ng-container *ngIf="isPlaning === true">

                                <!-- start zones count -->
                                <div class="col-12">
                                    <div class="wrap_full_control">
                                        <app-label [required]="true" title="عدد المناطق"></app-label>
                                        <div class="wrap_box">
                                            <ng-select 
                                                [items]="Floors"
                                                class="text-center"
                                                [clearable]="false"
                                                [searchable]="true"
                                                formControlName="zonesCount"
                                                placeholder="اختيار عدد المناطق"
                                                notFoundText="لا يوجد مناطق متاحة!"
                                                (change)="ChildrenCountHandler($event, ZonesControl)"
                                            />
                                        </div>
                                        <div class="wrap_validation">
                                            <app-validation-input 
                                                class="mb-0"
                                                [text]="'هذا الحقل مطلوب'"
                                                *ngIf="control('zonesCount')?.touched && control('zonesCount')?.errors"
                                            >
                                            </app-validation-input>
                                        </div>
                                    </div>
                                </div>
                                <!-- end zones count -->

                                <!-- start ZonesControl -->
                                <ng-container *ngIf="ZonesControl?.controls?.length > 0">
                                    <div class="col-12 units">
                                        <div class="hr my-2"></div>
                                        <div class="row mt-3 wrap_units custom_scroll align-content-start">
                                            <ng-container formArrayName='zones'>
                                                <ng-container *ngFor="let unit of ZonesControl.controls; let i = index; let control as index">
                                                    <div class="row border_solid_2 border_main_color border_radius_2 margin_bottom_6 padding_y_2">
                                                        <ng-container [formGroupName]="i">
                                                            <div class="col-12 col-md-6">
                                                                <app-label title="اسم الزون" [required]="true" />
                                                                <div class="wrap_input">
                                                                    <app-input-field
                                                                        type="text"
                                                                        name="name"
                                                                        formControlName="name"
                                                                        placeholder="... اكتب هنا"
                                                                        [validatorsErrorMsg]="true"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-12 col-md-6">
                                                                <app-label title="متوسط السعر" [required]="true" />
                                                                <div class="wrap_input">
                                                                    <app-input-field
                                                                        type="text"
                                                                        convertToAmount
                                                                        removeZerosAtFirst
                                                                        name="averagePrice"
                                                                        placeholder="... اكتب هنا"
                                                                        [validatorsErrorMsg]="true"
                                                                        formControlName="averagePrice"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-12 margin_top_2">
                                                                <ng-select 
                                                                    bindValue="id"
                                                                    [multiple]="true"
                                                                    [clearable]="false"
                                                                    class="text-center md"
                                                                    formControlName="lands"
                                                                    bindLabel="unitNumber"
                                                                    [closeOnSelect]="false"
                                                                    placeholder="اختيار الوحدات"
                                                                    notFoundText="لا يوجد وحدات متاحة!"
                                                                    [items]="filteredUnits$ | async"
                                                                />
                                                                <div class="wrap_validation">
                                                                    <app-validation-input 
                                                                        class="mb-0"
                                                                        [text]="'هذا الحقل مطلوب'"
                                                                        *ngIf="control.get('lands')?.touched && control.get('lands')?.errors"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </div>
                                </ng-container>
                                <!-- start ZonesControl -->

                            </ng-container>
                            <!-- end Planing -->
    
                            <!-- start Villas -->
                            <ng-container *ngIf="isVillas === true">
                                <div class="col-12">
                                    <div class="wrap_full_control">
                                        <app-label title="الفلل"></app-label>
                                        <div class="wrap_box">
                                            <ng-select 
                                                bindValue="id"
                                                [items]="Villas"
                                                [multiple]="true"
                                                class="text-center"
                                                [clearable]="false"
                                                [closeOnSelect]="false"
                                                bindLabel="unitNumber"
                                                formControlName="villas"
                                                placeholder="اختيار الفيلا"
                                                notFoundText="لا يوجد فلل متاحة!"
                                            >
                                            </ng-select>
                                            <div class="wrap_validation">
                                                <app-validation-input 
                                                    class="mb-0"
                                                    [text]="'هذا الحقل مطلوب'"
                                                    *ngIf="control('villas')?.touched && control('villas')?.errors"
                                                >
                                                </app-validation-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- end Villas -->

                            <!-- start Villas -->
                            <ng-container *ngIf="isOffPlanSale === true">
                                <div class="col-12">
                                    <div class="wrap_full_control">
                                        <app-label title="العمارات" />
                                        <div class="wrap_box">
                                            <ng-select 
                                                bindValue="id"
                                                [multiple]="true"
                                                [items]="Buildings"
                                                class="text-center"
                                                [clearable]="false"
                                                [closeOnSelect]="false"
                                                bindLabel="unitNumber"
                                                formControlName="buildings"
                                                placeholder="اختيار العمارة"
                                                notFoundText="لا يوجد عماير متاحة!"
                                            />
                                            <div class="wrap_validation">
                                                <app-validation-input 
                                                    class="mb-0"
                                                    [text]="'هذا الحقل مطلوب'"
                                                    *ngIf="control('buildings')?.touched && control('buildings')?.errors"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- end Villas -->                            

                        </div>

                    </ng-container>
                    <!-- end Bundled units -->                    

                    <!-- start others details -->
                    
                    <!-- start priceType field -->
                     <!-- <ng-container>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="wrap_box">
                               <app-radio-button 
                                   label="علي السوم"
                                   name="priceType"
                                   [value]="PriceType.soom"
                                   formControlName="priceType"
                                   (Change)="PriceTypeToggle($event)"
                               />
                            </div>
                        </div>
                     </ng-container>

                    <ng-container *ngIf="IShowStartFromPriceType">
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="wrap_box">
                                <app-radio-button 
                                    label="تبدأ الأسعار من"
                                    name="priceType"
                                    formControlName="priceType" 
                                    [value]="PriceType.startsFrom"
                                    (Change)="PriceTypeToggle($event)"
                                />
                            </div>
                        </div>
                    </ng-container> -->
                    <!-- end priceType field -->

                    <!-- start location -->
                    <ng-container>
                        <div class="col-12 location">
                            <div class="wrap_full_control">
                                <app-label 
                                    for="location"
                                    class="pointer" 
                                    title="موقع العقار على الخريطة"
                                >
                                </app-label>
                                <div class="wrap_box">
                                    <div 
                                        (click)="ShowPopupMap()"
                                        [class.disabled]="IsMapDisabled"
                                        [class.active]="IsMapHasGetCoords && CurrentMapAddress !== null"
                                        class="box_location overflow-hidden position-relative border_r pointer text-center d-flex align-items-center justify-content-center"
                                    >
                                        <ng-container *ngIf="isLoadingGeocoder === true; else withOutGeocoder">
                                            <app-loader [preventScroll]="true" [sm]="true" size="fa-sm"  />
                                            <span class="color_gray label_lg_bold d-block">جاري تحميل العنوان المحدد</span>
                                        </ng-container>

                                        <ng-template #withOutGeocoder>
                                            <ng-container *ngIf="IsMapDisabled === false && CurrentMapAddress === null">
                                                <img 
                                                    class="me-2"
                                                    alt="locicon mapation" 
                                                    src="/assets/img/{{(IsMapHasGetCoords && CurrentMapAddress !== null) ? 'location.svg' : 'location_w_0.5.svg'}}" 
                                                />
                                            </ng-container>
                                            <ng-container *ngIf="IsMapDisabled === true">
                                                <span class="color_wrong label_lg_bold d-block">يجب اختيار الحى قبل تحديد الموقع</span>
                                            </ng-container>
                                            <ng-container *ngIf="IsMapDisabled === false && IsMapHasGetCoords !== null && CurrentMapAddress === null">
                                                <span class="color_gray label_lg_bold d-block">يجب تحديد الموقع داخل ابعاد الحى</span>
                                            </ng-container>                                        
                                            <ng-container *ngIf="CurrentMapAddress !== null">
                                                <span class="address label_lg_bold">
                                                    {{CurrentMapAddress}}
                                                </span>
                                            </ng-container>
                                        </ng-template>
                                    </div>
                                </div>
                                <span class="color_wrong label_lg_bold d-block mt-2 ms-3">
                                    * يرجي التاكد من موقع العقارالخاص بك *
                                </span>
                            </div>
                            
                            <ng-container *ngIf="PopupMap">
                                <div 
                                    @fade
                                    (click)="HidePopupMap()"
                                    class="wrap_map position-fixed d-flex align-items-center justify-content-center flex-column" 
                                >
                                    <div class="wrap_close" (click)="HidePopupMap()">
                                        <app-close></app-close>
                                    </div>
                                    <google-map 
                                        width="100%"
                                        height="80vh"
                                        [center]="MapCoords"
                                        class="w-100 overflow-hidden"
                                        [options]="googleMapsOptions"
                                        (mapInitialized)="Map = $event"
                                        (idle)="MapCenterCoords()"
                                        (click)="$event.stopPropagation()"
                                        (mapClick)="GetNewCoords($event?.latLng)"
                                    >
                                        <map-marker 
                                            [position]="Coords"
                                            [options]="{draggable: true}"
                                            (mapDragend)="GetNewCoords($event?.latLng)"
                                        />
                                    </google-map>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <!-- end location -->

                    <!-- start imgs -->
                    <div class="col-12 mt-5 mb-4">
                        <app-label class="mb-1" [required]="true" title="إضافة صور العقار"></app-label>
                        <app-file-upload-field
                            name="imgs"
                            [limit]="15"
                            [server]="true"
                            accept="image/*"
                            [multiple]="true"
                            formControlName="imgs"
                            title="إضافة صور العقار"
                            [filesTypes]="[
                                FileTypes.svg,
                                FileTypes.jpg,
                                FileTypes.png,
                                FileTypes.img
                            ]"
                        />
                    </div>
                    <!-- end imgs -->

                    <!-- start adsFile -->
                    <div class="col-12 col-md-6 mb-3">
                        <app-label class="mb-2" title="ملف التصميم"></app-label>
                        <app-file-upload-field 
                            name="adsFile"
                            [server]="true"
                            title="ملف التصميم"
                            formControlName="adsFile"
                            [singleFileInArray]="true"
                            thumbnailIcons="/assets/img/file-2.svg"
                            [filesTypes]="[
                                FileTypes.doc,
                                FileTypes.csv,
                                FileTypes.pdf,
                                FileTypes.word,
                                FileTypes.document,                                
                            ]"
                        />
                    </div>
                    <!-- end adsFile -->

                    <!-- start sketch -->
                    <div class="col-12 col-md-6 mb-3">
                        <app-label class="mb-2" [title]="ControlLabelValueType.sketchLabel"></app-label>
                        <app-file-upload-field 
                            name="sketch"
                            [server]="true"
                            formControlName="sketch"
                            [singleFileInArray]="true"
                            thumbnailIcons="/assets/img/file-2.svg"
                            [title]="ControlLabelValueType.sketchLabel"
                            [filesTypes]="[
                                FileTypes.doc,
                                FileTypes.csv,
                                FileTypes.pdf,
                                FileTypes.word,
                                FileTypes.document,
                            ]"
                        />
                    </div>
                    <!-- end sketch -->  
                     
                    <!-- start contract -->
                    <ng-container *ngIf="control('contract').enabled">
                        <div class="col-12 mb-3">
                            <app-label class="mb-2" title="ملف العقد"></app-label>
                            <app-file-upload-field 
                                name="contract"
                                [server]="true"
                                title="ملف العقد"
                                formControlName="contract"
                                [singleFileInArray]="true"
                                thumbnailIcons="/assets/img/file-2.svg"
                                [filesTypes]="[
                                    FileTypes.doc,
                                    FileTypes.word,
                                    FileTypes.document,
                                ]"
                            />
                        </div>
                    </ng-container>
                    <!-- end contract -->
                    
                    <!-- start link3D -->
                    <div class="col-12">
                        <app-label title="رابط التجول الافتراضى"></app-label>
                        <div class="wrap_input">
                            <app-input-field
                                type="url"
                                name="link3D"
                                formControlName="link3D"
                                [validatorsErrorMsg]="true"
                                placeholder="ضع الرابط هنا.."
                            />
                        </div>
                    </div>
                    <!-- end link3D -->

                    <!-- start properties -->
                    <div class="col-12 properties position-relative" [class.is_loading]="IsLoadingProperties === true" >
                        <div class="row">
                            <ng-container *ngIf="IsLoadingProperties === true">
                                <app-loader [preventScroll]="true" [sm]="true" size="fa-5x" />
                                <div class="col-12">
                                    <h3 class="label_lg_bold text-center empty mt-5">جاري تحميل الموصفات...</h3>   
                                </div>
                            </ng-container>
    
                            <!-- start MainProperties -->
                            <ng-container *ngIf="MainProperties.length > 0">
        
                                <div class="col-12">
                                    <div class="wrap_full_control">
                                        <app-label class="main_color" title="مواصفات رئيسية" />
                                    </div>
                                </div>
        
                                <ng-container formArrayName="properties">
                                    <ng-container *ngFor="let control of MainPropertiesControl; let i = index">
                                        <ng-container [formGroupName]="i">
            
                                            <!-- start FeaturesType list -->
                                            <ng-container *ngIf="MainProperties[i].type == FeaturesType.list">
                                                <div class="col-12 col-md-6 col-lg-4">
                                                    <div class="wrap_full_control">
                                                        <app-label [required]="MainProperties[i].required" [title]="MainProperties[i].name" />
                                                        <div class="wrap_select_box">
                                                            <ng-select 
                                                                bindValue="id"
                                                                bindLabel="name"
                                                                [clearable]="false"
                                                                [searchable]="false"
                                                                class="sm text-center"
                                                                formControlName="value"
                                                                [items]="MainProperties[i].options"
                                                                [placeholder]="MainProperties[i].name"
                                                                notFoundText="لا يوجد اختيارات متاحة!"
                                                            >
                                                            </ng-select>
                                                            <div class="wrap_validation m-0">
                                                                <app-validation-input 
                                                                    class="mb-0"
                                                                    [text]="'هذا الحقل مطلوب'"
                                                                    *ngIf="control.get('value')?.touched && control.get('value')?.errors"
                                                                >
                                                                </app-validation-input>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Column spacer -->
                                                <ng-container *ngIf="MainProperties[i + 1].type !== FeaturesType.list">
                                                    <div class="col-12"></div>
                                                </ng-container>
                                            </ng-container>
                                            <!-- end FeaturesType list -->
        
                                            <!-- start FeaturesType number -->
                                            <ng-container *ngIf="MainProperties[i].type == FeaturesType.number">
                                                <div class="col-12 col-md-6 col-lg-4">
                                                    <div class="wrap_full_control">
                                                        <app-label [required]="MainProperties[i].required" [title]="MainProperties[i].name" />
                                                        <app-input-field
                                                            type="text"
                                                            [name]="'value'"
                                                            matchNumbersOnly
                                                            removeZerosAtFirst
                                                            formControlName="value"
                                                            placeholder="... اكتب هنا"
                                                            [validatorsErrorMsg]="true"
                                                        />
                                                    </div>
                                                </div>
                                            </ng-container>
                                            <!-- end FeaturesType number -->
            
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <!-- end MainProperties -->
        
                            <!-- start SubProperties -->
                            <ng-container *ngIf="SubProperties.length > 0">
                                
                                <div class="col-12">
                                    <div class="wrap_full_control">
                                        <app-label class="main_color" title="مواصفات فرعية" />
                                    </div>
                                </div>
        
                                <ng-container formArrayName="features">
                                    <ng-container *ngFor="let control of SubPropertiesControl; let i = index">
                                        <div class="col-12 col-md-6 col-lg-4">
                                            <div class="wrap_box d-flex flex-column">
                                                <div class="wrap">
                                                    <app-check-box
                                                        [formControlName]="i"
                                                        [value]="SubProperties[i]?.id"
                                                        [name]="SubProperties[i]?.name"
                                                        [label]="SubProperties[i]?.name"
                                                        [markAsRequired]="SubProperties[i]?.required"                                                
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
        
                            </ng-container>
                            <!-- end SubProperties -->
                        </div>
                    </div>
                    <!-- end properties -->

                    <div class="col-12">
                        <div class="wrap_full_control">
                            <app-label 
                                title="تفاصيل أخرى"
                            >
                            </app-label>
                        </div>
                    </div>

                    <!-- start saudiBuildingCode -->
                    <!-- <div class="col-12">
                        <div class="wrap_box d-flex align-items-center">
                            <app-check-box 
                                name="saudiBuildingCode"
                                [disabledLineThrough]="false"
                                formControlName="saudiBuildingCode" 
                                label="هل العقار مطابق لي كود البناء السعودي"
                            />
                        </div>
                    </div> -->
                    <!-- end saudiBuildingCode -->

                    <!-- start contraindications -->
                    <!-- <div class="col-12 col-md-6">
                        <div class="wrap_box d-flex align-items-center">
                            <app-check-box 
                                name="contraindications"
                                [disabledLineThrough]="false"
                                formControlName="contraindications" 
                                label="هل يوجد قيود تمنع التصرف فى العقار"
                            />
                        </div>
                    </div>

                    <ng-container *ngIf="control('contraindications').value">
                        <div class="wrap_select_box" @fade>
                            <app-box-text-area 
                                matchLettersWithNumbers
                                [validatorsErrorMsg]="true"
                                placeholder="... اكتب شرح القيود"
                                formControlName="contraindicationsDesc"
                                
                            />
                        </div>
                    </ng-container> -->
                    <!-- end contraindications -->

                    <!-- start undocumentedRights -->
                    <!-- <div class="col-12 col-md-6">
                        <div class="wrap_box d-flex align-items-center">
                            <app-check-box 
                                name="undocumentedRights"
                                [disabledLineThrough]="false"
                                formControlName="undocumentedRights" 
                                label="هل يوجد حقوق غير موثقه للعقار"
                            />
                        </div>
                    </div>

                    <ng-container *ngIf="control('undocumentedRights').value">
                        <div class="wrap_select_box" @fade>
                            <app-box-text-area 
                                matchLettersWithNumbers
                                [validatorsErrorMsg]="true"
                                placeholder="... اكتب شرح الحقوق"
                                formControlName="undocumentedRightsDesc"
                                
                            />
                        </div>
                    </ng-container> -->
                    <!-- end undocumentedRights -->

                    <!-- start influentialInformation -->
                    <!-- <div class="col-12 col-md-6">
                        <div class="wrap_box d-flex align-items-center">
                            <app-check-box 
                                name="influentialInformation"
                                [disabledLineThrough]="false"
                                formControlName="influentialInformation" 
                                label="هل يوجد معلومات تؤثر على العقار"
                            />
                        </div>
                    </div>

                    <ng-container *ngIf="control('influentialInformation').value">
                        <div class="wrap_select_box" @fade>
                            <app-box-text-area 
                                matchLettersWithNumbers
                                [validatorsErrorMsg]="true"
                                placeholder="... اكتب شرح المعلومات"
                                formControlName="influentialInformationDesc"
                                
                            />
                        </div>
                    </ng-container> -->
                    <!-- end influentialInformation -->

                    <!-- start guarantees -->
                    <!-- <div class="col-12 col-md-6">
                        <div class="wrap_box d-flex align-items-center">
                            <app-check-box 
                                name="guarantees"
                                [disabledLineThrough]="false"
                                label="هل يوجد ضمانات"
                                formControlName="guarantees" 
                            />
                        </div>
                    </div>

                    <ng-container *ngIf="control('guarantees').value">
                        <div class="wrap_select_box" @fade>
                            <app-box-text-area 
                                matchLettersWithNumbers
                                [validatorsErrorMsg]="true"
                                formControlName="guaranteesDesc"
                                placeholder="... اكتب شرح الضمانات"
                                
                            />
                        </div>
                    </ng-container> -->
                    <!-- end guarantees -->
                    
                    <!-- start description -->
                    <div class="col-12">
                        <div class="wrap_full_control">
                            <app-label [required]="true" title="مواصفات اخرى"></app-label>
                            <div class="wrap_select_box">
                                <app-box-text-area 
                                    matchLettersWithNumbers
                                    [validatorsErrorMsg]="true"
                                    formControlName="description_ar"
                                    placeholder="... اكتب المواصفات الاخرى"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- end description -->

                    <!-- start bestFeature -->
                    <div class="col-12">
                        <div class="wrap_full_control">
                            <app-label [required]="true" title="افضل المميزات"></app-label>
                            <div class="wrap_select_box">
                                <app-box-text-area 
                                    matchLettersWithNumbers
                                    [validatorsErrorMsg]="true"
                                    formControlName="bestFeature_ar"
                                    placeholder="... اكتب افضل المميزات"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- ebd bestFeature -->

                    <!-- stat next -->
                    <div class="col-12 text-center">
                        <div class="wrap_btn">
                            <app-btn 
                                title="تالي"
                                [submit]="false"
                                (click)="forward()"
                                icon="/assets/img/arrow-w.svg"
                                [disabled]="Form.invalid || Form.pending  || IsLoading"
                            />
                        </div>
                    </div>  
                    <!-- end next -->
                    
                </div>
            </div>

            <!-- staart PreviewCurrentFormData -->
            <ng-container *ngIf="PreviewCurrentFormData != null">
                <div class="info_realty">

                    <h4 class="label_lg_bold">معلومات العقار</h4>
    
                    <div class="wrap_info_realty">
                        <app-preview-ad-data 
                            (bill)="BillInfo = $event"
                            [errorMsg]="ErrorsResponse"
                            [info]="PreviewCurrentFormData" 
                            [showBill]="isOperationCreatedMode"
                            [crud]="(routeData | async).curd"
                            [adType]="(routeData | async).type" 
                        />
                    </div>
                    
                    <div class="btns text-center">
                        <app-btn 
                            title="تعديل" 
                            [submit]="false"
                            (click)="backward()"
                            [style]="{backgroundColor: '#009FB4'}"
                        >
                        </app-btn>
                        <app-btn 
                            [submit]="true"
                            [title]="isOperationCreatedMode ? 'ارسال' : 'حفظ'"
                        />   
                    </div>
    
                </div>
            </ng-container> 
            <!-- staart PreviewCurrentFormData -->

        </form>
    </div>
</div>
<!-- start app-build-ad -->